<!--<div *ngIf="recs">
  <div>
    <button class="btn btn-default" type="button" (click)="back('/rec-search')">
      <i class="fa fa-caret-left" style="margin-right:2px"></i>Back
    </button>
    <label class="lbl-text">Recorded Land Search Results</label>
    <label>South Essex</label>
  </div>
  <div class="ml-10" *ngFor="let r of recs | async">
    <label class="lbl-text">Business/LastName:</label>
    <label> {{ r.lastcorpName }}</label>

    <label class="lbl-text">Role:</label>
    <label *ngIf="r.roleID==='1'">Grantor</label>
    <label *ngIf="r.roleID==='2'">Grantee</label>
    <label *ngIf="r.roleID==='0'">Both Grantor and Grantee</label>
    <label *ngIf="r.roleID<0">All Roles</label>
    
    <label class="lbl-text">Date:</label>
    <label>{{r.fromDate| date:'MM-dd-yyyy'}}</label>

    <label class="lbl-text">to</label>
    <label>{{r.toDate| date:'MM-dd-yyyy'}}</label>
  </div>
  <div class="ml-10">
    <label class="lbl-text">Document Category:</label>
    <label></label>

    <label class="lbl-text">Document Type:</label>
    <label></label>
  </div>
</div>-->

<div class="info-strip grid clearfix">
  <div class="info-strip-left grid">
    <button class="back-button" type="button" (click)="back('/rec-name-search')">
      <i class="fa fa-caret-left"></i><p>Back</p>
    </button>
  </div>
  <!--<div class="info-strip-right grid" *ngFor="let r of recs.rec ">-->
  <div class="info-strip-right grid" >
    <div class="criteria">
      <h2>Recorded Land Search Results</h2>
      <h3>{{latestRecording}}</h3>
      <p>
        <strong>Name: </strong> {{ recs.name.name[0].lastcorpName }}, {{ recs.name.name[0].fName }}
        <strong> Role: </strong>
        <label *ngIf="recs.role.role[0].roleID==1">Grantor</label>
        <label *ngIf="recs.role.role[0].roleID==2">Grantee</label>
        <label *ngIf="recs.role.role[0].roleID==0">Both</label>
        <strong> Date: </strong> {{recs.date.date[0].fromDate| date:'MM-dd-yyyy'}} to {{recs.date.date[0].toDate| date:'MM-dd-yyyy'}}
        <strong> City/Town: </strong> <label *ngIf="towns.length===0">All</label>
        <label *ngIf="towns.length>0 && towns.length<5">{{towns}}</label>
        <label *ngIf="towns.length>4">MULTIPLE</label>
        <!--<label *ngIf="towns.length===2">{{towns[0]}},{{towns[1]}}</label>-->
        <!--<strong>Category:</strong> All-->
        <strong> Type: </strong> <label *ngIf="types.length===0">All</label>
        <label *ngIf="types.length>0 && types.length<5">{{types}}</label>
        <label *ngIf="types.length>4">MULTIPLE</label>
        <label *ngIf="recordCount > 9999; else elseBlock">
          <span style="color:red"><strong>&nbsp; {{recordCount}}</strong> records returned - additional records available.</span>
        </label>
        <ng-template #elseBlock><strong>&nbsp; {{recordCount}}</strong> records found</ng-template>
        <label *ngIf="recordCount != filteredRecordCount"> <strong> &nbsp;&nbsp;{{filteredRecordCount}} </strong> filtered records</label>
      </p>
    </div>
    <!--<div class="grid-right-icons">
      <img tabindex="0" class="email-img" src="images/email.png">
      <div class="filter-toggle"><p>Filter Results ></p></div>
    </div>-->
  </div>
</div>
